import React, { Component } from "react";
import { message, Row, Col, Tag, Upload, Alert, Space, Collapse, Empty } from "antd";
import { DownloadOutlined, UploadOutlined, SaveOutlined } from "@ant-design/icons";
import axios from "axios";
import { connect } from "react-redux";
import * as XLSX from "xlsx";
import { ButtonItem, TableItem, ModalItem, MensajeError } from "../../../../Components/Items";
import EditorMotivosEtapa, { motivosParaGuardar } from "./EditorMotivosEtapa";
import { descargarPlantillaMotivos, filasMotivosDesdeHoja } from "./plantillaMotivosEtapas";

const estadoInicial = { loading: false, etapas: [], motivosPorEtapa: {}, etapasModificadas: [], resultado: null };

class ModalMotivosFlujoPU extends Component {
  state = { ...estadoInicial };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.setState({ ...estadoInicial }, this.cargarDatos);
    }
  }

  cargarDatos = () => {
    this.setState({ loading: true });
    return axios
      .post(
        "motivosEtapaOrdenProduccionPU/datosPlantillaMotivos",
        { empresaId: this.props.empresaId, flujoId: this.props.flujo._id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success !== 2) {
          MensajeError({ message: res.data.error || "Error al cargar los motivos" });
          return null;
        }
        const motivosPorEtapa = {};
        (res.data.motivos || []).forEach((motivo) => {
          if (!motivosPorEtapa[motivo.etapaId]) motivosPorEtapa[motivo.etapaId] = [];
          motivosPorEtapa[motivo.etapaId].push(motivo);
        });
        this.setState({
          etapas: [...(res.data.etapas || [])].sort((a, b) => (a.orden || 0) - (b.orden || 0)),
          motivosPorEtapa,
          etapasModificadas: [],
        });
        return res.data;
      })
      .catch(() => {
        this.setState({ loading: false });
        MensajeError({ message: "Error al conectar con el servidor" });
        return null;
      });
  };

  cambiarMotivos = (etapaId, motivos) => {
    this.setState((prev) => ({
      motivosPorEtapa: { ...prev.motivosPorEtapa, [etapaId]: motivos },
      etapasModificadas: prev.etapasModificadas.includes(etapaId) ? prev.etapasModificadas : [...prev.etapasModificadas, etapaId],
    }));
  };

  guardar = async () => {
    const { etapasModificadas, motivosPorEtapa } = this.state;
    if (etapasModificadas.length === 0) {
      message.info("No hay cambios por guardar");
      return;
    }
    this.setState({ loading: true });
    let desactivados = 0;
    try {
      for (const etapaId of etapasModificadas) {
        const res = await axios.post(
          "motivosEtapaOrdenProduccionPU/guardarMotivosEtapa",
          { empresaId: this.props.empresaId, etapaId, motivos: motivosParaGuardar(motivosPorEtapa[etapaId] || []) },
          { headers: this.props.headersToken }
        );
        if (res.data.success !== 2) {
          const etapa = this.state.etapas.find((e) => e._id === etapaId);
          MensajeError({ message: `${etapa?.nombre || "Etapa"}: ${res.data.error || "No se pudieron guardar los motivos"}` });
          this.setState({ loading: false });
          return;
        }
        desactivados += res.data.desactivados || 0;
      }
    } catch (error) {
      this.setState({ loading: false });
      MensajeError({ message: "Error al conectar con el servidor" });
      return;
    }
    message.success("Motivos guardados correctamente");
    if (desactivados > 0) message.info(`${desactivados} motivo(s) ya usados en movimientos se desactivaron en lugar de eliminarse`);
    this.cargarDatos();
  };

  descargarPlantilla = () => {
    descargarPlantillaMotivos({
      flujo: this.props.flujo,
      etapas: this.state.etapas,
      motivos: Object.values(this.state.motivosPorEtapa).flat().filter((m) => m._id && m.estado !== 2),
    });
  };

  onSubirArchivo = ({ file }) => {
    if (this.state.etapasModificadas.length > 0) {
      message.warning("Guarda tus cambios antes de subir un Excel");
      return;
    }
    if (!/\.xlsx?$/i.test(file.name || "")) {
      message.error("El archivo debe ser un Excel (.xlsx/.xls)");
      return;
    }
    const reader = new FileReader();
    reader.onloadend = (e) => {
      let filas;
      try {
        const libro = XLSX.read(new Uint8Array(e.target.result), { type: "array" });
        const nombreHoja = libro.SheetNames.find((n) => n.toLowerCase() === "motivos") || libro.SheetNames[0];
        filas = filasMotivosDesdeHoja(XLSX, libro.Sheets[nombreHoja]);
      } catch (error) {
        message.error("No se pudo leer el archivo. Verifica que sea un Excel válido.");
        return;
      }
      if (!filas) {
        message.error("No se encontraron las columnas Etapa y Nombre en el archivo.");
        return;
      }
      if (filas.length === 0) {
        message.error("El archivo no tiene renglones con motivos.");
        return;
      }
      this.importar(filas);
    };
    reader.readAsArrayBuffer(file.originFileObj || file);
  };

  importar = (filas) => {
    this.setState({ loading: true });
    axios
      .post(
        "motivosEtapaOrdenProduccionPU/importarMotivos",
        { empresaId: this.props.empresaId, flujoId: this.props.flujo._id, filas },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          this.cargarDatos().then(() => this.setState({ resultado: res.data }));
        } else {
          MensajeError({ message: res.data.error || "No se pudieron importar los motivos" });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        MensajeError({ message: "Error al conectar con el servidor" });
      });
  };

  renderResultado() {
    const { resultado } = this.state;
    if (!resultado) return null;
    return (
      <div style={{ marginBottom: 16 }}>
        <Space size="middle" style={{ marginBottom: 8 }}>
          <Tag color="green">Creados: {resultado.creados}</Tag>
          <Tag color="blue">Actualizados: {resultado.actualizados}</Tag>
          <Tag>Sin cambios: {resultado.sinCambios}</Tag>
          <Tag color={resultado.errores.length ? "red" : "default"}>Con error: {resultado.errores.length}</Tag>
        </Space>
        {resultado.errores.length > 0 && (
          <>
            <Alert
              type="warning"
              showIcon
              style={{ marginBottom: 8 }}
              message="Estos renglones no se cargaron. Corrígelos en el Excel y vuelve a subirlo; lo que ya se cargó no se duplica."
            />
            <TableItem
              size="small"
              pagination={false}
              dataSource={resultado.errores}
              rowKey="fila"
              columns={[
                { title: "Renglón", dataIndex: "fila", key: "fila", width: 90 },
                { title: "Error", dataIndex: "mensaje", key: "mensaje" },
              ]}
            />
          </>
        )}
      </div>
    );
  }

  render() {
    const { flujo, puedeEditar, visible, onCerrar } = this.props;
    const { etapas, motivosPorEtapa, etapasModificadas } = this.state;

    return (
      <ModalItem
        title={`Motivos por etapa${flujo ? ` - ${flujo.nombre}` : ""}`}
        visible={visible}
        spinning={this.state.loading}
        onCancel={onCerrar}
        width="70%"
        paddingTop
      >
        {puedeEditar && (
          <Row gutter={8} style={{ marginBottom: 16 }} justify="end">
            <Col>
              <Space>
                <ButtonItem icon={<DownloadOutlined />} onClick={this.descargarPlantilla}>
                  Descargar plantilla
                </ButtonItem>
                <Upload showUploadList={false} customRequest={this.onSubirArchivo} accept=".xlsx,.xls">
                  <ButtonItem icon={<UploadOutlined />}>Subir Excel</ButtonItem>
                </Upload>
              </Space>
            </Col>
          </Row>
        )}

        {this.renderResultado()}

        {etapas.length === 0 ? (
          <Empty description="Este flujo no tiene etapas activas" />
        ) : (
          <Collapse>
            {etapas.map((etapa) => {
              const motivos = motivosPorEtapa[etapa._id] || [];
              const activos = motivos.filter((m) => m._id && m.estado !== 2).length;
              return (
                <Collapse.Panel
                  key={etapa._id}
                  header={
                    <span>
                      <b>{etapa.nombre}</b>{" "}
                      <Tag color={activos ? "cyan" : "default"} style={{ marginLeft: 8 }}>
                        {activos} motivo(s)
                      </Tag>
                      {etapasModificadas.includes(etapa._id) && <Tag color="orange">Sin guardar</Tag>}
                    </span>
                  }
                >
                  <EditorMotivosEtapa motivos={motivos} soloLectura={!puedeEditar} onChange={(lista) => this.cambiarMotivos(etapa._id, lista)} />
                </Collapse.Panel>
              );
            })}
          </Collapse>
        )}

        {puedeEditar && (
          <ButtonItem type="primary" icon={<SaveOutlined />} style={{ display: "block", margin: "16px 0 0 auto" }} onClick={this.guardar}>
            Guardar
          </ButtonItem>
        )}
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalMotivosFlujoPU);
